/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "काल",
        "0": "आयज",
        "1": "फाल्यां",
        "future": {
          "other": "{0} दिसानीं"
        },
        "past": {
          "other": "{0} दीस आदीं"
        }
      },
      "day-narrow": {
        "-1": "काल",
        "0": "आयज",
        "1": "फाल्यां",
        "future": {
          "other": "{0} दिसानीं"
        },
        "past": {
          "other": "{0} दीस आदीं"
        }
      },
      "day-short": {
        "-1": "काल",
        "0": "आयज",
        "1": "फाल्यां",
        "future": {
          "other": "{0} दिसानीं"
        },
        "past": {
          "other": "{0} दीस आदीं"
        }
      },
      "hour": {
        "0": "हें वर",
        "future": {
          "other": "{0} वरांनीं"
        },
        "past": {
          "other": "{0} वरा आदीं"
        }
      },
      "hour-narrow": {
        "0": "हें वर",
        "future": {
          "other": "{0} वरांनीं"
        },
        "past": {
          "other": "{0} वरा आदीं"
        }
      },
      "hour-short": {
        "0": "हें वर",
        "future": {
          "other": "{0} वरांनीं"
        },
        "past": {
          "other": "{0} वरा आदीं"
        }
      },
      "minute": {
        "0": "हें मिनीट",
        "future": {
          "other": "{0} मिन्टां"
        },
        "past": {
          "other": "{0} मिन्टां आदीं"
        }
      },
      "minute-narrow": {
        "0": "हें मिनीट",
        "future": {
          "other": "{0} मिन्टां"
        },
        "past": {
          "other": "{0} मिन्टां आदीं"
        }
      },
      "minute-short": {
        "0": "हें मिनीट",
        "future": {
          "other": "{0} मिन्टां"
        },
        "past": {
          "other": "{0} मिन्टां आदीं"
        }
      },
      "month": {
        "-1": "फाटलो म्हयनो",
        "0": "हो म्हयनो",
        "1": "फुडलो म्हयनो",
        "future": {
          "other": "{0} म्हयन्यानीं"
        },
        "past": {
          "other": "{0} म्हयन्यां आदीं"
        }
      },
      "month-narrow": {
        "-1": "फाटलो म्हयनो",
        "0": "हो म्हयनो",
        "1": "फुडलो म्हयनो",
        "future": {
          "other": "{0} म्हयन्यानीं"
        },
        "past": {
          "other": "{0} म्हयन्यां आदीं"
        }
      },
      "month-short": {
        "-1": "फाटलो म्हयनो",
        "0": "हो म्हयनो",
        "1": "फुडलो म्हयनो",
        "future": {
          "other": "{0} म्हयन्यानीं"
        },
        "past": {
          "other": "{0} म्हयन्यां आदीं"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "फाटलो त्रैमासीक",
        "0": "हो त्रैमासीक",
        "1": "फुडलो त्रैमासीक",
        "future": {
          "other": "{0} त्रैमासीकांत"
        },
        "past": {
          "other": "{0} त्रैमासीकां आदीं"
        }
      },
      "quarter-narrow": {
        "-1": "फाटलो त्रैमासीक",
        "0": "हो त्रैमासीक",
        "1": "फुडलो त्रैमासीक",
        "future": {
          "other": "{0} त्रैमासीकांत"
        },
        "past": {
          "other": "{0} त्रैमासीकां आदीं"
        }
      },
      "quarter-short": {
        "-1": "फाटलो त्रैमासीक",
        "0": "हो त्रैमासीक",
        "1": "फुडलो त्रैमासीक",
        "future": {
          "other": "{0} त्रैमासीकांत"
        },
        "past": {
          "other": "{0} त्रैमासीकां आदीं"
        }
      },
      "second": {
        "0": "आतां",
        "future": {
          "other": "{0} सेकंदानीं"
        },
        "past": {
          "other": "{0} सेकंद आदीं"
        }
      },
      "second-narrow": {
        "0": "आतां",
        "future": {
          "other": "{0} सेकंदानीं"
        },
        "past": {
          "other": "{0} से. आदीं"
        }
      },
      "second-short": {
        "0": "आतां",
        "future": {
          "other": "{0} सेकंदानीं"
        },
        "past": {
          "other": "{0} से. आदीं"
        }
      },
      "week": {
        "-1": "निमाणो सप्तक",
        "0": "हो सप्तक",
        "1": "फुडलो सप्तक",
        "future": {
          "other": "{0} सप्तकांनीं"
        },
        "past": {
          "other": "{0} सप्तकां आदीं"
        }
      },
      "week-narrow": {
        "-1": "निमाणो सप्तक",
        "0": "हो सप्तक",
        "1": "फुडलो सप्तक",
        "future": {
          "other": "{0} सप्तकांनीं"
        },
        "past": {
          "other": "{0} सप्त. आदीं"
        }
      },
      "week-short": {
        "-1": "निमाणो सप्तक",
        "0": "हो सप्तक",
        "1": "फुडलो सप्तक",
        "future": {
          "other": "{0} सप्तकांनीं"
        },
        "past": {
          "other": "{0} सप्तकां आदीं"
        }
      },
      "year": {
        "-1": "फाटलें वर्स",
        "0": "हें वर्स",
        "1": "फुडलें वर्स",
        "future": {
          "other": "{0} वर्सांनीं"
        },
        "past": {
          "other": "{0} वर्सां आदीं"
        }
      },
      "year-narrow": {
        "-1": "फाटलें वर्स",
        "0": "हें वर्स",
        "1": "फुडलें वर्स",
        "future": {
          "other": "{0} वर्सांनीं"
        },
        "past": {
          "other": "{0} वर्स आदीं"
        }
      },
      "year-short": {
        "-1": "फाटलें वर्स",
        "0": "हें वर्स",
        "1": "फुडलें वर्स",
        "future": {
          "other": "{0} वर्सांनीं"
        },
        "past": {
          "other": "{0} वर्स आदीं"
        }
      }
    },
    "locale": "kok"
  });
}